import { IAutoRenewalStatus, ISubscriptions } from './types';

export enum ESubscriptionsActionType {
  GET = 'SUBSCRIPTIONS/GET',
  GET_SUCCESS = 'SUBSCRIPTIONS/GET/SUCCESS',
  GET_AUTO_RENEWAL_STATUS = 'SUBSCRIPTIONS/GET_AUTO_RENEWAL_STATUS',
  GET_AUTO_RENEWAL_STATUS_SUCCESS = 'SUBSCRIPTIONS/GET_AUTO_RENEWAL_STATUS_SUCCESS',
  POST_REACTIVATED = 'SUBSCRIPTIONS/POST_REACTIVATED',
  BUY = 'SUBSCRIPTIONS/BUY',
  RESTORE = 'SUBSCRIPTION/RESTORE',
  CANCELRA = 'SUBSCRIPTION/CANCEL_RA',
}

export interface IGetSubscriptionsAction {
  type: ESubscriptionsActionType.GET;
}

export const getSubscriptionsAction = (): IGetSubscriptionsAction => ({
  type: ESubscriptionsActionType.GET,
});

export interface IGetSubscriptionsSuccessAction {
  type: ESubscriptionsActionType.GET_SUCCESS;
  payload: ISubscriptions;
}

export const getSubscriptionsSuccessAction = (
  subscription: ISubscriptions
): IGetSubscriptionsSuccessAction => ({
  type: ESubscriptionsActionType.GET_SUCCESS,
  payload: subscription,
});

export interface IGetAutoRenewalStatusAction {
  type: ESubscriptionsActionType.GET_AUTO_RENEWAL_STATUS;
}

export const getAutoRenewalStatusAction = (): IGetAutoRenewalStatusAction => ({
  type: ESubscriptionsActionType.GET_AUTO_RENEWAL_STATUS,
});

export interface IGetAutoRenewalStatusSuccessAction {
  type: ESubscriptionsActionType.GET_AUTO_RENEWAL_STATUS_SUCCESS;
  payload: IAutoRenewalStatus;
}

export const getAutoRenewalStatusSuccessAction = (
  autoRenewalStatus: IAutoRenewalStatus
): IGetAutoRenewalStatusSuccessAction => ({
  type: ESubscriptionsActionType.GET_AUTO_RENEWAL_STATUS_SUCCESS,
  payload: autoRenewalStatus,
});

export interface IPostReactivateAutoRenewalAction {
  type: ESubscriptionsActionType.POST_REACTIVATED;
}

export const postReactivateAutoRenewalAction = (): IPostReactivateAutoRenewalAction => ({
  type: ESubscriptionsActionType.POST_REACTIVATED,
});

export interface IBuySubscriptionAction {
  type: ESubscriptionsActionType.BUY;
  payload: {
    productId: string;
  };
}

export const buySubscriptionAction = (
  productId: string
): IBuySubscriptionAction => ({
  type: ESubscriptionsActionType.BUY,
  payload: { productId },
});

export interface IRestorePaymentAction {
  type: ESubscriptionsActionType.RESTORE;
}

export const restorePaymentAction = (): IRestorePaymentAction => ({
  type: ESubscriptionsActionType.RESTORE,
});

export interface ICancelAutoRenewalAction {
  type: ESubscriptionsActionType.CANCELRA;
  payload: {
    reason: string;
  };
}

export const cancelAutoRenewalAction = (reason: string) => ({
  type: ESubscriptionsActionType.CANCELRA,
  payload: { reason },
});

export type ISubscriptionsAction =
  | IGetSubscriptionsAction
  | IGetSubscriptionsSuccessAction
  | IGetAutoRenewalStatusAction
  | IGetAutoRenewalStatusSuccessAction
  | IPostReactivateAutoRenewalAction
  | IBuySubscriptionAction;
